import { publicImageURL } from '../context/Firebase/FirebaseConfig';

export function getPublicAvatarURL(avatarSlug: string): string {
  return avatarSlug ? `${publicImageURL}${avatarSlug}` : '';
}
